export enum Composition {
  SPECIFIC_COMPOSITION = "Specific Composition",
  SPECIFIC_HEATING_VALUE = "Specific Heating Value",
}

export const CompositionDropdown = [
  {
    label: "Specific Composition",
    value: "Specific Composition",
  },
  {
    label: "Specific Heating Value",
    value: "Specific Heating Value",
  },
];

export const HeatingValueUnit = [
  {
    label: "Kcal/Kg",
    value: "Kcal/Kg",
  },
  {
    label: "Kcal/M3",
    value: "Kcal/M3",
  },
];

export enum GAS_UNIT {
  KCAL_KG = "Kcal/Kg",
  KCAL_M3 = "Kcal/M3",
}

export const VolumeByOption = [
  {
    label: "%Open Valve",
    value: "%Open Valve",
  },
  {
    label: "Flow Meter",
    value: "Flow Meter",
  },
];

export enum VolumeByEnum {
  FLOW_METER = "Flow Meter",
  OPEN_VALUE = "%Open Valve",
}

export const SentOneStackOfFlareOption = [
  {
    label: "Yes",
    value: "Yes",
  },
  {
    label: "No",
    value: "No",
  },
];

export enum SentOneStackOfFlareEnum {
  YES = "Yes",
  NO = "No",
}

export enum FlareCaseEnum {
  TURNAROUND = "turnaround",
  EMERGENCY = "emergency",
  NORMAL_OPERATE = "normalOperate",
}

export const flareCaseFilter = [
  {
    text: "Normal Operate",
    value: "normalOperate",
  },
  {
    text: "Emergency",
    value: "emergency",
  },
  {
    text: "Turnaround",
    value: "turnaround",
  },
];

export const flareCaseFilterDropdown = [
  {
    label: "Normal Operate",
    value: "normalOperate",
  },
  {
    label: "Emergency",
    value: "emergency",
  },
  {
    label: "Turnaround",
    value: "turnaround",
  },
];

export const flareCaseFilterDropdownWithAll = [
  {
    label: "All",
    value: "normalOperate,emergency,turnaround",
  },
  {
    label: "Normal Operate",
    value: "normalOperate",
  },
  {
    label: "Emergency",
    value: "emergency",
  },
  {
    label: "Turnaround",
    value: "turnaround",
  },
];

export const ListFlareCaseWithTotal = ["Normal Operate", "Turnaround", "Emergency", "Total"];

export enum TitleFlareCase {
  NORMAL_OPERATE = "Normal Operate",
  TURNAROUND = "Turnaround",
  EMERGENCY = "Emergency",
  TOTAL = "Total",
}

export const MapFlareCaseLabelToValue = {
  "Normal Operate": "normalOperate",
  Turnaround: "turnaround",
  Emergency: "emergency",
  Total: "total",
};

export const MapFlareCaseLabelToTotalValue = {
  "Normal Operate": "totalNormalOperate",
  Turnaround: "totalTurnaround",
  Emergency: "totalEmergency",
  Total: "total",
};

export const DefaultObjectVocIntensity = {
  jan: {
    Kg: 0,
    Ton: 0,
  },
  feb: {
    Kg: 0,
    Ton: 0,
  },
  mar: {
    Kg: 0,
    Ton: 0,
  },
  apr: {
    Kg: 0,
    Ton: 0,
  },
  may: {
    Kg: 0,
    Ton: 0,
  },
  jun: {
    Kg: 0,
    Ton: 0,
  },
  jul: {
    Kg: 0,
    Ton: 0,
  },
  aug: {
    Kg: 0,
    Ton: 0,
  },
  sep: {
    Kg: 0,
    Ton: 0,
  },
  oct: {
    Kg: 0,
    Ton: 0,
  },
  nov: {
    Kg: 0,
    Ton: 0,
  },
  dec: {
    Kg: 0,
    Ton: 0,
  },
  total: {
    Kg: 0,
    Ton: 0,
  },
  label: "VOCs Intensity (Total)",
  key: "VocIntensity",
  unit: "g/Ton",
};
